import { render, staticRenderFns } from "./ShoppingCartModal.vue?vue&type=template&id=1b8b8402&scoped=true"
import script from "./ShoppingCartModal.vue?vue&type=script&lang=js"
export * from "./ShoppingCartModal.vue?vue&type=script&lang=js"
import style0 from "./ShoppingCartModal.vue?vue&type=style&index=0&id=1b8b8402&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8b8402",
  null
  
)

export default component.exports